/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Action_LabelInputs */

const en_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Media`)
};

const fr_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer le media`)
};

const de_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importmedien`)
};

const it_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa media`)
};

const ru_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт медиафайлов`)
};

const es_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar medios`)
};

const zh_cn2_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进口媒体`)
};

const ja_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポート`)
};

const hi_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात मीडिया`)
};

const pt_pt2_media_import_action_label = /** @type {(inputs: Media_Import_Action_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia de importação`)
};

/**
* | output |
* | --- |
* | "Import Media" |
*
* @param {Media_Import_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_action_label = /** @type {((inputs?: Media_Import_Action_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Action_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_action_label(inputs)
	if (locale === "de") return de_media_import_action_label(inputs)
	if (locale === "it") return it_media_import_action_label(inputs)
	if (locale === "ru") return ru_media_import_action_label(inputs)
	if (locale === "es") return es_media_import_action_label(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_action_label(inputs)
	if (locale === "ja") return ja_media_import_action_label(inputs)
	if (locale === "hi") return hi_media_import_action_label(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_action_label(inputs)
	return en_media_import_action_label(inputs)
});